var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"bg-white m-0 p-2"},[_c('label',[_vm._v("Serial")]),_c('SerialSearch',{attrs:{"showModalResults":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }